import React from "react";
import { Modal } from "react-blueprint-library";
import { isSafari } from "../../../../common/Functions";
import UploadFileSection from "./UploadFileSection";

const bodyStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "32px",
};

const headerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const footerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  marginTop: "24px",
};

const loadingStyle = {
  position: "absolute",
  left: "45px",
  top: "2px",
};

export default function UploadModal(props) {
  let notes = [];

  if (
    props.isRequested &&
    props.requestedDocs &&
    props.requestedDocs.length > 0
  ) {
    /* Group requestedDocs by note */
    notes = Array.from(
      new Set(props.requestedDocs.map((doc) => doc.note))
    ).filter(Boolean);
  }

  return (
    <div>
      <Modal
        id="uploadModal"
        show={props.isOpen}
        className={isSafari ? "modal-md safari-only-wrapper" : "modal-md"}
        title=""
        centered
      >
        <div style={{ padding: ".2rem" }}>
          <div className="modal-body">
            <div className="row" style={bodyStyle}>
              <div className="col-md-12" style={headerStyle}>
                <div>
                  <h2
                    style={{
                      color: "#000",
                      margin: 0,
                      fontSize: 20,
                      fontWeight: "600",
                      lineHeight: "30px",
                      letterSpacing: "0.25px",
                      wordWrap: "break-word",
                    }}
                  >
                    Submit documents
                  </h2>
                </div>
                <div style={{ marginTop: 10 }}>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close modal dialog"
                    onClick={props.onClose}
                    style={{ margin: 0, padding: 0 }}
                  />
                </div>
              </div>
            </div>
            <main style={{ padding: "0 32px" }}>
              <div>
                <h3
                  style={{
                    color: "#000",
                    margin: 0,
                    fontSize: 16,
                    fontWeight: "700",
                    lineHeight: "24px",
                    wordWrap: "break-word",
                  }}
                >
                  Application:
                </h3>
                <p>{props.contracttype}</p>
              </div>

              {props.isRequested &&
              props.requestedDocs &&
              props.requestedDocs.length > 0 ? (
                <>
                  <div>
                    <h3
                      style={{
                        color: "#000",
                        margin: 0,
                        fontSize: 16,
                        fontWeight: "700",
                        lineHeight: "24px",
                        wordWrap: "break-word",
                      }}
                    >
                      Instructions from your onboarding team:
                    </h3>
                    {notes.length <= 1 ? (
                      <p
                        style={{
                          wordWrap: "break-word",
                        }}
                      >
                        {notes[0]}
                      </p>
                    ) : (
                      <ul style={{ padding: "8px", marginLeft: "15px" }}>
                        {notes.map((note, idx) => (
                          <li
                            key={idx}
                            style={{
                              fontSize: 16,
                              fontWeight: "400",
                              lineHeight: "24px",
                              wordWrap: "break-word",
                            }}
                          >
                            {note}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div>
                    <h3
                      style={{
                        color: "#000",
                        margin: 0,
                        fontSize: 16,
                        fontWeight: "700",
                        lineHeight: "24px",
                        wordWrap: "break-word",
                      }}
                    >
                      Requested file types:
                    </h3>
                    <ul
                      style={{
                        padding: "8px",
                        marginLeft: "15px",
                      }}
                    >
                      {props.requestedDocs.map((doc, idx) => (
                        <li
                          style={{
                            fontSize: 16,
                            fontWeight: "400",
                            lineHeight: "24px",
                            wordWrap: "break-word",
                          }}
                          key={idx}
                        >
                          {doc.typedesc}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div>
                    <p
                      style={{
                        fontSize: 16,
                        fontWeight: "400",
                        lineHeight: "24px",
                        wordWrap: "break-word",
                      }}
                    >
                      <strong
                        style={{
                          color: "#000",
                          margin: 0,
                          fontSize: 16,
                          fontWeight: "700",
                          lineHeight: "24px",
                          wordWrap: "break-word",
                        }}
                      >
                        Important:
                      </strong>{" "}
                      Please include the file type in the name of the
                      document(s) you are uploading. Example: “YourName_W9”
                    </p>
                  </div>

                  <div>
                    <span
                      style={{
                        color: "rgba(0, 0, 0, 0.85)",
                        fontSize: "14px",
                        fontWeight: "390",
                        lineHeight: "20px",
                        wordWrap: "break-word",
                      }}
                    >
                      Fields marked * are required.
                    </span>
                  </div>
                </>
              ) : null}

              <div
                style={{
                  color: "#000",
                  marginTop: "15px",
                  marginBottom: "25px",
                }}
              >
                <UploadFileSection
                  files={props.files}
                  onFilesChange={props.onFilesChange}
                  isLoading={props.isLoading}
                />
              </div>
            </main>
            <div className="row" style={{ padding: "0 32px" }}>
              <div className="col-md-12">
                <div style={footerStyle}>
                  <button
                    type="button"
                    className="btn btn-link"
                    onClick={props.onClose}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    variant="primary"
                    style={{ textTransform: "capitalize" }}
                    onClick={props.onUpload}
                    disabled={!props.canSubmit || props.isLoading}
                  >
                    {props.isLoading ? (
                      <div
                        className="mm-dots-loading-md"
                        role="img"
                        aria-label="MassMutual Logo"
                        id="mm-spinner"
                        style={{ ...loadingStyle }}
                      />
                    ) : (
                      <>Submit</>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
